import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';

export default function DepoDetay() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [depo, setDepo] = useState(null);
  const [hareketler, setHareketler] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tab, setTab] = useState('stok');
  const [arama, setArama] = useState('');
  const [filtreFirma, setFiltreFirma] = useState('');
  const [filtreGrup, setFiltreGrup] = useState('');
  const [firmalar, setFirmalar] = useState([]);
  const [tumUrunler, setTumUrunler] = useState([]);
  const [stokMap, setStokMap] = useState({}); // urun_id -> { id, miktar }
  const [duzenlenen, setDuzenlenen] = useState({}); // urun_id -> yeni miktar string

  useEffect(() => { fetchData(); }, [id]);

  async function fetchData() {
    const [{ data: d }, { data: s }, { data: h }, { data: u }, { data: f }] = await Promise.all([
      supabase.from('depolar').select('*').eq('id', id).single(),
      supabase.from('depo_stok').select('*').eq('depo_id', id),
      supabase.from('stok_hareketleri').select('*, urunler(ad)').eq('depo_id', id).order('created_at', { ascending: false }).limit(50),
      supabase.from('urunler').select('id, ad, grup, alt_grup, firma_id, firmalar(ad)').eq('aktif', true),
      supabase.from('firmalar').select('id, ad').eq('aktif', true),
    ]);

    setDepo(d);
    setHareketler(h || []);
    setFirmalar(f || []);

    const map = {};
    (s || []).forEach(st => { map[st.urun_id] = { id: st.id, miktar: st.miktar }; });
    setStokMap(map);

    const sorted = (u || []).sort((a, b) => {
      const grupA = (a.alt_grup || '').trim();
      const grupB = (b.alt_grup || '').trim();
      if (grupA !== grupB) return grupA.localeCompare(grupB, 'tr');
      const na = parseInt((a.ad.match(/[0-9]+/) || ['0'])[0]);
      const nb = parseInt((b.ad.match(/[0-9]+/) || ['0'])[0]);
      if (na !== nb) return na - nb;
      return a.ad.localeCompare(b.ad, 'tr');
    });
    setTumUrunler(sorted);
    setLoading(false);
  }

  async function satirdanGuncelle(urun) {
    const yeniMiktar = parseInt(duzenlenen[urun.id]);
    const mevcutMiktar = stokMap[urun.id]?.miktar || 0;

    if (isNaN(yeniMiktar) || yeniMiktar === mevcutMiktar) {
      setDuzenlenen(d => { const n = { ...d }; delete n[urun.id]; return n; });
      return;
    }

    const fark = Math.abs(yeniMiktar - mevcutMiktar);
    const tip = yeniMiktar > mevcutMiktar ? 'giris' : 'cikis';

    await supabase.from('depo_stok').upsert(
      { depo_id: id, urun_id: urun.id, miktar: yeniMiktar },
      { onConflict: 'depo_id,urun_id' }
    );
    await supabase.from('stok_hareketleri').insert({
      depo_id: id, urun_id: urun.id, hareket_tipi: tip,
      miktar: fark, onceki_stok: mevcutMiktar, sonraki_stok: yeniMiktar, aciklama: 'Direkt düzenleme'
    });

    setDuzenlenen(d => { const n = { ...d }; delete n[urun.id]; return n; });
    fetchData();
  }

  const altGruplar = [...new Set(
    tumUrunler
      .filter(u => !filtreFirma || String(u.firma_id) === String(filtreFirma))
      .map(u => (u.alt_grup || '').trim())
      .filter(Boolean)
  )].sort();

  const filtreliUrunler = tumUrunler.filter(u => {
    if (arama && !u.ad.toLowerCase().includes(arama.toLowerCase())) return false;
    if (filtreFirma && String(u.firma_id) !== String(filtreFirma)) return false;
    if (filtreGrup && (u.alt_grup || '').trim() !== filtreGrup.trim()) return false;
    return true;
  });

  const gruplar = [...new Set(filtreliUrunler.map(u => (u.alt_grup || 'Diğer').trim()))].sort();
  const toplamStokta = Object.values(stokMap).filter(s => s.miktar > 0).length;
  const harTipi = { giris: '📥', cikis: '📤', transfer_giris: '🔄', transfer_cikis: '🔄', iade: '↩', sayim: '🔢' };

  if (loading) return <div className="loading">Yükleniyor...</div>;

  return (
    <div>
      <div className="page-header">
        <div>
          <button className="btn btn-ghost btn-sm" onClick={() => navigate('/depolar')} style={{ marginBottom: 8 }}>← Depolar</button>
          <h1 className="page-title">{depo?.ad}</h1>
          <p className="page-subtitle">{depo?.sehir} • {toplamStokta} ürün çeşidi stokta</p>
        </div>
      </div>

      <div className="tabs">
        <button className={`tab-btn ${tab === 'stok' ? 'active' : ''}`} onClick={() => setTab('stok')}>Stok Durumu</button>
        <button className={`tab-btn ${tab === 'hareketler' ? 'active' : ''}`} onClick={() => setTab('hareketler')}>Stok Hareketleri</button>
      </div>

      {tab === 'stok' && (
        <>
          <div style={{ display: 'flex', gap: 8, marginBottom: 16, flexWrap: 'wrap' }}>
            <input
              className="input"
              placeholder="Ürün ara..."
              value={arama}
              onChange={e => setArama(e.target.value)}
              style={{ maxWidth: 220 }}
            />
            <select className="select" value={filtreFirma} onChange={e => { setFiltreFirma(e.target.value); setFiltreGrup(''); }} style={{ maxWidth: 200 }}>
              <option value="">Tüm Firmalar</option>
              {firmalar.map(f => <option key={f.id} value={f.id}>{f.ad}</option>)}
            </select>
            <select className="select" value={filtreGrup} onChange={e => setFiltreGrup(e.target.value)} style={{ maxWidth: 200 }}>
              <option value="">Tüm Gruplar</option>
              {altGruplar.map(g => <option key={g} value={g}>{g}</option>)}
            </select>
            {(arama || filtreFirma || filtreGrup) && (
              <button className="btn btn-ghost btn-sm" onClick={() => { setArama(''); setFiltreFirma(''); setFiltreGrup(''); }}>Temizle</button>
            )}
          </div>

          {gruplar.map(grup => {
            const grupUrunler = filtreliUrunler.filter(u => (u.alt_grup || 'Diğer').trim() === grup);
            return (
              <div key={grup} style={{ marginBottom: 24 }}>
                <div style={{ fontSize: 13, fontWeight: 700, color: 'var(--primary)', textTransform: 'uppercase', letterSpacing: 1, marginBottom: 8 }}>
                  📦 {grup}
                </div>
                <div className="card" style={{ padding: 0 }}>
                  <table className="table">
                    <thead>
                      <tr><th>Ürün</th><th>Firma</th><th>Stok</th><th>Durum</th></tr>
                    </thead>
                    <tbody>
                      {grupUrunler.map(u => {
                        const miktar = stokMap[u.id]?.miktar || 0;
                        return (
                          <tr key={u.id}>
                            <td style={{ fontWeight: 500 }}>{u.ad}</td>
                            <td style={{ color: 'var(--text2)', fontSize: 13 }}>{u.firmalar?.ad}</td>
                            <td>
                              {duzenlenen[u.id] !== undefined ? (
                                <div style={{ display: 'flex', gap: 4, alignItems: 'center' }}>
                                  <input
                                    className="input"
                                    type="number"
                                    min="0"
                                    value={duzenlenen[u.id]}
                                    onChange={e => setDuzenlenen(d => ({ ...d, [u.id]: e.target.value }))}
                                    style={{ width: 80, padding: '4px 8px' }}
                                    autoFocus
                                    onKeyDown={e => {
                                      if (e.key === 'Enter') satirdanGuncelle(u);
                                      if (e.key === 'Escape') setDuzenlenen(d => { const n = { ...d }; delete n[u.id]; return n; });
                                    }}
                                  />
                                  <button className="btn btn-primary btn-sm" style={{ padding: '4px 8px' }} onClick={() => satirdanGuncelle(u)}>✓</button>
                                  <button className="btn btn-ghost btn-sm" style={{ padding: '4px 8px' }} onClick={() => setDuzenlenen(d => { const n = { ...d }; delete n[u.id]; return n; })}>✕</button>
                                </div>
                              ) : (
                                <span
                                  style={{ fontWeight: 700, fontSize: 16, cursor: 'pointer', padding: '2px 8px', borderRadius: 4, border: '1px dashed transparent' }}
                                  onMouseOver={e => e.target.style.borderColor = 'var(--border)'}
                                  onMouseOut={e => e.target.style.borderColor = 'transparent'}
                                  onClick={() => setDuzenlenen(d => ({ ...d, [u.id]: miktar }))}
                                  title="Düzenlemek için tıkla"
                                >
                                  {miktar}
                                </span>
                              )}
                            </td>
                            <td>
                              {miktar === 0
                                ? <span className="badge badge-red">Tükendi</span>
                                : miktar <= 5
                                  ? <span className="badge badge-yellow">Kritik</span>
                                  : <span className="badge badge-green">Normal</span>}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            );
          })}

          {filtreliUrunler.length === 0 && (
            <div style={{ textAlign: 'center', padding: 60, color: 'var(--text2)' }}>Ürün bulunamadı</div>
          )}
        </>
      )}

      {tab === 'hareketler' && (
        <div className="card" style={{ padding: 0 }}>
          <table className="table">
            <thead>
              <tr><th>Tarih</th><th>Ürün</th><th>İşlem</th><th>Miktar</th><th>Önceki</th><th>Sonraki</th><th>Açıklama</th></tr>
            </thead>
            <tbody>
              {hareketler.length === 0 ? (
                <tr><td colSpan={7} style={{ textAlign: 'center', padding: 40, color: 'var(--text2)' }}>Hareket kaydı yok</td></tr>
              ) : hareketler.map(h => (
                <tr key={h.id}>
                  <td style={{ fontSize: 12, color: 'var(--text2)' }}>{new Date(h.created_at).toLocaleString('tr-TR')}</td>
                  <td>{h.urunler?.ad}</td>
                  <td>{harTipi[h.hareket_tipi]} {h.hareket_tipi}</td>
                  <td style={{ fontWeight: 600, color: h.hareket_tipi === 'giris' || h.hareket_tipi === 'transfer_giris' ? 'var(--green)' : 'var(--red)' }}>{h.miktar}</td>
                  <td style={{ color: 'var(--text2)' }}>{h.onceki_stok}</td>
                  <td style={{ fontWeight: 600 }}>{h.sonraki_stok}</td>
                  <td style={{ color: 'var(--text2)', fontSize: 12 }}>{h.aciklama || '-'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
